import { shippingLabelTemplateIdFormat } from "@redotech/redo-fulfillment-id";
import { defaultShippingLabelTemplate } from "@redotech/redo-fulfillment-operations-common/shipping-label/shipping-label-template-defaults";
import { shippingLabelTemplateSchema } from "@redotech/redo-fulfillment-operations-common/shipping-label/shipping-label-template-definition";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getOrCreateMerchantPrimaryShippingLabelTemplate = unaryRpc({
  name: "getOrCreateMerchantPrimaryShippingLabelTemplate" as const,
  input: z.object({}),
  output: shippingLabelTemplateSchema,
  mock: {
    ...defaultShippingLabelTemplate,
    id: shippingLabelTemplateIdFormat.write(1n),
    name: "Default shipping label",
    createdAt: "2026-01-01T00:00:00.000Z",
    updatedAt: "2026-01-01T00:00:00.000Z",
  },
});
